module.exports = __webpack_public_path__ + "img/icons8-porsche.598b4d00.png";